var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTooManyFilters = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 153 319"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "too-many-filters_svg__a",
  d: "M0 0h400v400H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-123 -40)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "too-many-filters_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#too-many-filters_svg__a"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  mask: "url(#too-many-filters_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M265.001 340.422h-11.045c-2.462 0-4.476-2.003-4.476-4.452v-1.514c0-2.448 2.014-4.452 4.476-4.452h11.045c2.462 0 4.476 2.004 4.476 4.452v1.514c0 2.449-2.014 4.452-4.476 4.452",
  fill: "#4E4E4E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M253.574 329.846h-97.702c-2.462 0-4.476-2.003-4.476-4.452v-15.088c0-2.45 2.014-4.452 4.476-4.452h97.702c2.462 0 4.476 2.002 4.476 4.452v15.088c0 2.449-2.014 4.452-4.476 4.452",
  fill: "#D82E2E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.287 358.26H150.16c-2.462 0-4.477-2.004-4.477-4.453v-37.188c0-2.448 2.015-4.452 4.477-4.452h109.128c2.462 0 4.477 2.004 4.477 4.452v37.188c0 2.449-2.015 4.452-4.477 4.452",
  fill: "#E15C5C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.997 324.129h75.865s-40.313 15.784-75.865 0m77.452 22.169h-75.864s40.312-15.785 75.864 0",
  fill: "#D82E2E"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M212.699 304.212l58.27-6.344-.322-2.93-58.27 6.344z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.288 303.778l-37.8 4.116c-2.447.266-4.669-1.507-4.937-3.941l-1.49-13.535c-.268-2.434 1.515-4.644 3.963-4.91l37.8-4.116c2.447-.266 4.669 1.507 4.937 3.942l1.49 13.535c.268 2.433-1.515 4.643-3.963 4.91",
  fill: "#0068B3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M265.181 276.531l-10.979 1.195c-2.447.267-4.669-1.507-4.936-3.941l-.166-1.504c-.268-2.435 1.515-4.644 3.962-4.91l10.98-1.196c2.447-.267 4.669 1.507 4.936 3.941l.166 1.505c.269 2.434-1.515 4.644-3.963 4.91",
  fill: "#4E4E4E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M252.665 267.255l-109.743 11.948c-2.447.266-4.669-1.507-4.936-3.941l-1.652-14.999c-.268-2.434 1.516-4.644 3.963-4.91l109.743-11.948c2.448-.267 4.668 1.507 4.937 3.94l1.65 15c.269 2.434-1.514 4.643-3.962 4.91",
  fill: "#0068B3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M261.453 294.88l-121.102 13.186c-2.447.266-4.67-1.508-4.937-3.942l-4.069-36.966c-.268-2.435 1.516-4.644 3.963-4.911l121.102-13.185c2.448-.266 4.67 1.508 4.938 3.942l4.068 36.966c.268 2.435-1.515 4.644-3.963 4.91",
  fill: "#2E83C0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M261.453 294.88l-121.102 13.186c-2.447.266-4.67-1.508-4.937-3.942l-4.069-36.966c-.268-2.435 1.516-4.644 3.963-4.911l121.102-13.185c2.448-.266 4.67 1.508 4.938 3.942l4.068 36.966c.268 2.435-1.515 4.644-3.963 4.91",
  fill: "#2E83C0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0068B3",
  d: "M133.598 287.628L263.6 273.475l-.437-3.976-130.002 14.154z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2E83C0",
  d: "M133.437 286.164l130.002-14.154-.115-1.046-130.002 14.154z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M273.114 298.904l-4.645.506a2.429 2.429 0 01-2.675-2.135l-.07-.645a2.422 2.422 0 012.146-2.66l4.645-.505a2.428 2.428 0 012.674 2.134l.072.645a2.421 2.421 0 01-2.147 2.66",
  fill: "#4E4E4E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M202.719 213.608l-61.22 12.356c-2.413.487-4.788-1.078-5.277-3.478l-2.386-11.694c-.49-2.399 1.084-4.76 3.497-5.248l61.22-12.355c2.412-.487 4.787 1.077 5.277 3.478l2.386 11.693c.49 2.4-1.084 4.761-3.497 5.248",
  fill: "#202020"
}), /*#__PURE__*/React.createElement("path", {
  d: "M215.526 240.66l-75.218 15.18c-2.413.487-4.788-1.077-5.278-3.477l-6.868-33.66c-.49-2.4 1.085-4.762 3.497-5.25l75.219-15.18c2.412-.487 4.787 1.078 5.277 3.478l6.868 33.66c.49 2.4-1.084 4.762-3.497 5.249",
  fill: "#4E4E4E"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#202020",
  d: "M131.975 237.389l83.992-16.951-.757-3.714-83.993 16.953z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M131.691 235.997l83.993-16.952-.19-.928-83.992 16.951z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M195.192 248.522l-33.077 6.676a1.964 1.964 0 01-2.309-1.522l-.104-.514a1.953 1.953 0 011.53-2.296l33.076-6.675a1.964 1.964 0 012.309 1.52l.104.515a1.954 1.954 0 01-1.53 2.296",
  fill: "#202020"
}), /*#__PURE__*/React.createElement("path", {
  d: "M191.876 100.072s4.588-4.582 4.899-10.482c.31-5.9-3.861-8.755-3.861-8.755l-.977.136s2.456 3.29 2.58 7.666l-.645.003s-1.087-4.631-2.808-7.49l-1.368.337s2.057 3.792 2.404 7.288l-.69-.107s-1.58-5.053-2.513-7.03l-1.287.431s1.532 3.875 1.958 6.613l-.682.017-1.772-6.473-1.218.704 1.625 6.96s-2.363 5.399 1.126 9.063l3.229 1.119z",
  fill: "#E2BB9F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.468 42.26s-27.725 2.95-23.965 33.01c3.761 30.06-8.113 50.086-8.113 50.086l58.14-1.038s-15.562-35.666 2.442-68.268l-28.504-13.79z",
  fill: "#202020"
}), /*#__PURE__*/React.createElement("path", {
  d: "M168.33 109.457l14.385 21.71 4.973-33.465 4.973.948-5.396 45.144-17.776-12.312s-10.465-12.586-1.158-22.025h-.001zm55.363 124.654s-.141 6.781.192 9.96l21.451-2.22s-.909-1.613-6.107-1.482c-5.199.13-9.976-7.03-9.976-7.03l-5.56.772z",
  fill: "#E2BB9F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M232.85 243.34s2.052-3.143 4.02-3.854l2.728.62-3.023 3.075-3.725.159z",
  fill: "#7F533B"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7F533B",
  d: "M245.738 244.009l-21.821 2.258-.234-2.238 21.821-2.258z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M223.693 234.111l-8.812-39.7-27.616.316 4.444-17.047 35.234 5.998 2.31 49.66s-1.509 4.8-5.56.773",
  fill: "#E2BB9F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194.565 173.575l35.87 5.683 4.448 59.874s-2.395 3.85-5.961.716l-9.598-48.278-26.98.632s-2.222-11.997 2.221-18.627zm-43.3-67.642l-8.378 6.835.493 59.21s13.83 7.778 32.14-1.682l-2.876-31.628 1.184-9.42-5.497-19.791-4.28-3.075-12.786-.449z",
  fill: "#F4D8BD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.172 80.162s.982 15.424-4.908 25.772c0 0 8.245 8.59 15.508 3.513 0 0-4.122-14.057-1.962-26.942l-8.638-2.343z",
  fill: "#F4D8BD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.153 101.905c-.852-5.236-1.502-12.485-.343-19.4l-6.767-1.835c-.609.808-1.217 1.847-1.82 3.154a69.123 69.123 0 01-.126 3.17l9.056 14.911z",
  fill: "#E2BB9F"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#F4D8BD"
}, /*#__PURE__*/React.createElement("path", {
  d: "M165.121 42.388s16.321-1.885 23.932 17.392l-1.496 5.209s-5.28-12.849-22.436-22.6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.046 78.653l4.148 11.795 34.835 3.079s4.163-13.61-5.971-38.49c-10.136-24.88-41.804-9.866-42.82 5.38-1.018 15.245 9.808 18.236 9.808 18.236"
}), /*#__PURE__*/React.createElement("path", {
  d: "M186.353 63.339l7.668 10.571-3.651 4.993-6.476-1.265z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#E2BB9F",
  d: "M194.021 73.91l-8.153 2.836-.852-3.014-1.122 3.906 6.476 1.265z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.791 76.489c-1.091-3.104-4.507-4.741-7.628-3.655-3.12 1.086-4.767 4.482-3.675 7.586.825 2.347 2.977 3.852 5.327 3.98a2.496 2.496 0 003.085 1.313 2.481 2.481 0 001.545-3.127 5.926 5.926 0 001.346-6.097",
  fill: "#F4D8BD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.816 74.34s2.397-3.04 6.293.155l5.562-12.966 1.213-11.758s5.13-2.282 21.333-.22c.58.074 2.631-1.192 2.631-1.192s-8.884-13.042-29.57-4.055c-20.687 8.988-10.821 26.792-7.462 30.036",
  fill: "#202020"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149.552 76.967c-.097-.276-2.478-1.724-3.404-1.402-.926.323-2.33 1.948-.919 5.077 1.413 3.129 4.22 1.946 4.22 1.946l1.649.253s-2.913-1.779-3.089-3.166c-.175-1.387 1.543-2.708 1.543-2.708",
  fill: "#E2BB9F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.406 82.2c1.403 1.072 3.042.387 3.042.387l1.65.254s-1.283-.786-2.198-1.72c-.491.602-1.436 1.014-2.494 1.08m-.258-6.635c-.419.145-.934.561-1.244 1.259.84.256 2.302.795 3.344 1.692.44-.883 1.304-1.55 1.304-1.55-.097-.277-2.478-1.724-3.404-1.401",
  fill: "#CEA284"
}), /*#__PURE__*/React.createElement("path", {
  d: "M182.759 62.383l2.465 3.305s-2.05 6.06-10.017 5.147l2.4-1.666s-7.212 1.914-13.186-4.206l5.898-3.952 12.44 1.372z",
  fill: "#E2BB9F"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#202020",
  d: "M163.92 64.899l6.765-3.185 12.074.669.769-2.877-13.837.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E2BB9F",
  d: "M188.366 60.778l-1.337 2.119.528 2.092 1.222-4.255z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M186.774 59.565l.255 3.332 2.169-1.72-.145-1.396-2.279-.216zm-14.698 6.953s4.24-1.533 7.091.801l-.76-1.993s-3.68-1.63-6.331 1.192zm-16.874-17.24s6.577 3.416 8.938 11.149l27.909-1.153s-2.613-24.756-31.178-17.315l-5.669 7.319z",
  fill: "#202020"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.49 57.595s1.885-9.924 18.618-14.32c16.734-4.393 23.495.562 27.829 4.224 0 0-26.581-10.36-46.448 10.096",
  fill: "#4C433E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M188.405 80.76s-1.994.902-2.115 2.284c-.121 1.384 1.813 1.744 2.66.842.845-.901-.545-3.126-.545-3.126",
  fill: "#202020"
}), /*#__PURE__*/React.createElement("path", {
  d: "M186.644 86.633s2.03 1.094 3.553-.673c1.522-1.766-.085-3.7-.085-3.7s2.622 2.354 1.522 4.878c-1.1 2.524-4.144 1.262-4.99-.505",
  fill: "#CEA284"
}), /*#__PURE__*/React.createElement("path", {
  d: "M228.922 239.848s-.028 6.782.358 9.956l21.411-2.574s-.936-1.598-6.132-1.382c-5.195.217-9.676-6.716-9.676-6.716l-5.961.716z",
  fill: "#F4D8BD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M238.232 248.925s2-3.178 3.953-3.92l2.74.574-2.972 3.125-3.721.221z",
  fill: "#8E6042"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8E6042",
  d: "M251.129 249.38l-21.781 2.618-.271-2.234 21.781-2.618z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.38 171.979l-2.777 1.912s.318 23.994 6.984 28.413c6.666 4.42 44.121-5.051 44.121-5.051s3.492-11.365 2.858-23.678l-19.046-3.278s-16.983 7.977-32.14 1.682",
  fill: "#5CAE8A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.587 202.304c6.665 4.42 44.122-5.05 44.122-5.05s.336-1.097.78-2.974l-.251-.395s-34.705 5.052-38.303 2.947c-3.597-2.104-2.962-11.365-2.962-11.365l4.02-3.157c6.137.21 9.523 9.47 9.523 9.47 2.328-10.522-9.1-13.68-9.1-13.68 11.08.658 17.507-5.11 19.787-7.663-2.35 1.029-17.856 7.343-31.823 1.542l-2.776 1.912s.317 23.994 6.983 28.413",
  fill: "#2E9769"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2E9769",
  d: "M164.516 191.781l25.394-2.105-25.606-.842z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.296 128.64s16.506-11.575 30.261-8.839l2.752 9.261-1.694 8.84 2.752 25.887s-13.755 10.733-35.763 3.578l1.692-38.727z",
  fill: "#E15C5C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M142.887 112.768s-6.727 5.139-9.055 13.347c-2.328 8.208-9.946 36.832-9.946 36.832s25.623 38.144 26.681 38.144c1.059 0 1.464-4.786 1.464-4.786L133.409 160l14.178-35.99s1.18-9.015-4.7-11.242",
  fill: "#F4D8BD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149.439 197.881s4.602-4.568 10.533-4.885c5.931-.317 8.808 3.83 8.808 3.83l-.135.97s-3.311-2.437-7.712-2.555l-.002.64s4.658 1.076 7.533 2.784l-.336 1.361s-3.815-2.041-7.33-2.382l.108.686s5.082 1.566 7.072 2.491l-.433 1.28s-3.897-1.518-6.65-1.938l-.018.677 6.511 1.755-.706 1.213-7-1.608s-5.425 2.357-9.115-1.109l-1.128-3.21z",
  fill: "#F4D8BD"
})))));
export default SvgTooManyFilters;